import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const CalendarDashboardGlobalMapSlice = createSlice({
  name: "calendarDashboardGlobalMap",
  initialState: {
    date: moment(new Date(Date.now())).format("YYYY"),
    quarter: moment().quarter()
  },
  reducers: {
    setState(state, action) {
      state.date = action.payload.date;
      state.quarter = action.payload.quarter;
    },
    clearState(state) {
      state.date = moment(new Date(Date.now())).format("YYYY");
      state.quarter = moment().quarter();
    }
  }
});

export default CalendarDashboardGlobalMapSlice;
export const CalendarDashboardGlobalMapSliceActions =
  CalendarDashboardGlobalMapSlice.actions;
